import type { MapBounds, MapPosition } from '../types/boxTruckMap'

export const BOX_TRUCK_MAP_DEFAULT_CENTER: MapPosition = { lat: 39.5, lng: -98.35 }
export const BOX_TRUCK_MAP_DEFAULT_ZOOM = 4
export const BOX_TRUCK_MAP_STATE_ZOOM = 6
export const BOX_TRUCK_MAP_DRIVER_ZOOM = 13
export const BOX_TRUCK_MAP_MAX_ZOOM = 16
export const BOX_TRUCK_MAP_STATE_MARKER_MAX_ZOOM = 7
export const BOX_TRUCK_MAP_CLUSTER_RADIUS = 72
export const BOX_TRUCK_MAP_CLUSTER_INSPECTION_LIMIT = 250
export const BOX_TRUCK_MAP_SEARCH_RESULT_LIMIT = 8
export const BOX_TRUCK_MAP_LOADS_MIN_ZOOM = 6
export const BOX_TRUCK_MAP_GEOCODE_TIMEOUT_MS = 10_000
export const BOX_TRUCK_MAP_ID = '9daae8dcb1ef420ff8a9e779'

export const BOX_TRUCK_MAP_DEFAULT_BOUNDS: MapBounds = {
    west: -128,
    south: 22,
    east: -65,
    north: 52,
}
